<app-sidenav page="product" menuType>

<div class="form-list" [ngClass]="{tablet: menuType==2}">

<div class="product-page">
<mat-card class="product-card">
  <mat-card-header>
    <mat-card-title>{{ product?.getName() }}</mat-card-title>
  </mat-card-header>
  <mat-card-footer [class]="'product-price'">
    <span *ngIf="product_qty">{{ 'product.qty' | translate }} {{ product_qty }}</span>
    {{ ((product?.getPrice() | number:'1.2-2') || '').replace(',',' ').replace('.',',') }}{{ currencysymbol }}          </mat-card-footer>
</mat-card>

<ng-image-slider
  class="img-slider"
  [imageSize]="imageSize"
  [manageImageRatio]="true"
  [images]="imageObject" #nav>
</ng-image-slider>

<div class="body"
  [ngClass]="{'three': colorVariants.length > 1, 'one': colorVariants.length == 1, 'zero': colorVariants.length == 0}">
  <p
    [innerHTML]="product?.getDescription() | pipeDescription">
  </p>
</div>

<div
  *ngIf="product?.getUrl()"
  class="link">
  <a class="pl-0" mat-flat-button target="_blank"
    href="{{ product?.getUrl() }}">
    {{ 'product.more_info' | translate }}
  </a>
</div>
<div #boxOption class="box-options" *ngIf="colorVariants.length > 0; else fallbackOptions">
  <!-- Color Selector Row -->
  <div class="variant-row">
    <span class="label">{{ 'product.color_label' | translate }}</span>
    <div class="color-chips">
      <button
        type="button"
        *ngFor="let item of colorVariants"
        (click)="selectColor(item.label)"
        [attr.aria-pressed]="selectedColor === item.label"
        class="color-chip"
        [class.color-chip--selected]="selectedColor === item.label">
          <span class="color-chip__swatch" [style.background-color]="item.bgcolor">
            <span
              *ngIf="selectedColor === item.label"
              class="color-chip__check"
              [style.color]="item.fgcolor">✓</span>
          </span>
          <span class="color-chip__label">
            {{ ('colors.COLOR_' + item.label) | translate }} 
          </span>
      </button>
    </div>
  </div>

  <!-- Size Availability Grid for Selected Color -->
  <div class="variant-row" *ngIf="selectedColor && activeVariantSizes.length > 0">
    <span class="label">{{ 'product.size_label' | translate }}</span>
    <div class="size-table">
      <div
        *ngFor="let item of activeVariantSizes"
        class="size-box"
        [class.size-box--oos]="product?.getQtyn() && item.qty === 0">
        <span class="size-box__size">{{ item.size }}</span>
        <span class="size-box__qty">
          {{ item.qty > 0 ? (item.qty + ' ' + ('product.left' | translate)) : ('product.qty0' | translate) }}
        </span>
      </div>
    </div>
  </div>
</div>

<!-- Fallback for non-variant products -->
<ng-template #fallbackOptions>
  <div #boxOption class="box-options" *ngIf="colorList(product) || product?.getSizesList()?.join(',')">
    <div class="row" *ngIf="colorList(product)">
      <div class="col1">{{ 'product.color_label' | translate }}</div>
      <div class="col2">{{ colorList(product) }}</div>
    </div>
    <div class="row" *ngIf="product?.getSizesList()?.join(',')">
      <div class="col1">{{ 'product.size_label' | translate }}</div>
      <div class="col2">{{ product?.getSizesList()?.join(',') }}</div>
    </div>
  </div>
</ng-template>
</div>
<div class="bottom">
  <button
    *ngIf="(product?.getQtyn() && product.getQt() > 0) || !product?.getQtyn() || (product?.getQt() === -1)"
    (click)="clickButton()"
    mat-raised-button
    [class]="'button-buy'">
    {{ 'product.button' | translate }}
  </button>
</div>

</div>

</app-sidenav>